import { useFeatureValue, useGrowthBook } from "@growthbook/growthbook-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { useShop } from "src/hooks/Utils/Shop/useShop";
import { GROWTHBOOK_FEATURES_KEYS } from "src/utils/growthBook/features";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";
import { CustomPageUniverseDto, normalizeUniverseV1, normalizeUniverseV3 } from "../../../Utils/universe";

export default function useUniverseQuery(): UseQueryResult<AxiosResponse<CustomPageUniverseDto, any>, unknown> {
  const { shopMarketId, shopLang } = useShop();
  const newUniverseApiVersion = useFeatureValue(GROWTHBOOK_FEATURES_KEYS.NEW_UNIVERSES_ENDPOINT_VERSION, true)
  const gb = useGrowthBook();

  const getUniverse = async () => {
    const response = await OpenapiSingleton.SearchUniverseAPIApi.listUniverses(
      shopMarketId,
      undefined,
      undefined,
      undefined,
      shopLang,
    );
    const normalizeData = normalizeUniverseV1(response.data);
    return {
      ...response,
      data: normalizeData
    }
  };

  const getUniverseV3 = async () => {
   const response = await OpenapiSingleton.Searchv3UniverseAPIApi.listUniverses(
      shopMarketId,
      undefined,
      undefined,
      undefined,
      shopLang,
    );
    
   const normalizeData = normalizeUniverseV3(response.data);
    return {
      ...response,
      data: normalizeData
    }
  };
  
  return useQuery<AxiosResponse<CustomPageUniverseDto, any>, unknown>({
    queryKey: ["getUniverse", newUniverseApiVersion?.toString(), shopMarketId, shopLang],
    queryFn: newUniverseApiVersion ? getUniverseV3 : getUniverse,
    staleTime: 3600000,
    enabled: gb.ready
  });
}
